import { render, staticRenderFns } from "./drawpigoffice.vue?vue&type=template&id=12e8d0d9&scoped=true&"
import script from "./drawpigoffice.vue?vue&type=script&lang=js&"
export * from "./drawpigoffice.vue?vue&type=script&lang=js&"
import style0 from "./drawpigoffice.vue?vue&type=style&index=0&id=12e8d0d9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e8d0d9",
  null
  
)

export default component.exports